import type { IDBPTransaction, StoreNames } from 'idb';

import type { DocStorageSchema } from './schema';

type PeerClockFields = Pick<
  DocStorageSchema['peerClocks']['value'],
  'clock' | 'pulledClock' | 'pushedClock'
>;

/** Max-put inside the caller's transaction; all unmentioned clocks are preserved. */
export async function putPeerClocksMax(
  tx: IDBPTransaction<
    DocStorageSchema,
    StoreNames<DocStorageSchema>[],
    'readwrite'
  >,
  peer: string,
  docId: string,
  clocks: Partial<PeerClockFields>
): Promise<void> {
  const store = tx.objectStore('peerClocks');
  const stored = await store.get([peer, docId]);
  const record = {
    peer,
    docId,
    clock: stored?.clock ?? new Date(0),
    pulledClock: stored?.pulledClock ?? new Date(0),
    pushedClock: stored?.pushedClock ?? new Date(0),
  };
  for (const field of ['clock', 'pulledClock', 'pushedClock'] as const) {
    const incoming = clocks[field];
    if (incoming)
      record[field] = new Date(
        Math.max(record[field].getTime(), incoming.getTime())
      );
  }
  await store.put(record);
}
